'use client';

import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { DeskTopCategoryGridCard, MobileCategoryGridCard, SectionTitle } from '@/widgets/landing/medicontents/ui/molecules';
import * as S from './styles';

const CategoryGridSection = () => {
  const isLg = useIsDesktop();

  return (
    <section id="category-grid-section" className={S.section}>
      <div className={S.Wrapper}>
        <SectionTitle
          title={{ text: '같은 블로그라도\n결과는 완전히 다릅니다.', color: 'text-white' }}
          subtitle={{ text: '상담이 이어지는 구조를 직접 경험해보세요.', color: 'text-[#D1D5DB]', gap: 'mt-2.5 md:mt-4' }}
        />
        {isLg ? <DeskTopCategoryGridCard /> : <MobileCategoryGridCard />}
      </div>
    </section>
  );
};

export default CategoryGridSection;
